import { createReducer } from "@reduxjs/toolkit";
import { adminValidateTeacherPayout, resetTeacherPayoutValidation } from "./validate-teacher-payout";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = { processing: "idle" };

export const adminValidateTeacherPayoutReducer = createReducer<ProcessingState>(initialState, builder => {
  builder
    .addCase(adminValidateTeacherPayout.pending, state => {
      state.processing = "pending";
    })
    .addCase(adminValidateTeacherPayout.fulfilled, state => {
      state.processing = "success";
    })
    .addCase(adminValidateTeacherPayout.rejected, state => {
      state.processing = "failed";
    })
    .addCase(resetTeacherPayoutValidation, () => initialState);
});
